import React, {useState, useEffect} from 'react';
import CreateUser from './CreateUser';
import '../css/App.css';
import '../css/bootstrap.min.css';
import Permissions from '../Permissions';
import refreshIcon from '../img/refresh.png';
import settingsIcon from '../img/settings.png';
import bootstrap from 'bootstrap'
import AllUsers from './AllUsers';


class UserBoard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user,
      permissions: this.props.permissions,
      userArray:[],
      userCreator:false,
      allUsersWindow:false,
      permissionForUserAdmin:false,
      interval: setInterval(
        () => { 
          this.loadUsers(); 
        }, 6000),
    };
    this.loadUsers = this.loadUsers.bind(this);
    this.opencloseUserCreation = this.opencloseUserCreation.bind(this);
    this.openCloseAllUsers = this.openCloseAllUsers.bind(this);
    this.checkPermission = this.checkPermission.bind(this);
  }

  loadUsers = async () => {
    let fetchRequest = await fetch("https://dashboard.realsexdoll.info/php/users/users.php");
    const result = await fetchRequest.json();
    this.setState({userArray:result});
  }

  opencloseUserCreation = () =>{
    let status = this.state.userCreator;
    this.setState({userCreator:!status})
  }

  checkPermission = async() =>{
    console.log("Checking Permission for admin Users...");
    let result = await Permissions.checkPermission(this.props.user,'userSettings');

    this.setState({permissionForUserAdmin:result})
    console.log(this.props.user);
    console.log(result);

  }

  openCloseAllUsers = () =>{
    let windowStatus = this.state.allUsersWindow;
    this.setState({allUsersWindow:!windowStatus});
  }

  componentDidMount = () =>{
    this.loadUsers();
    this.checkPermission();
  }
  render() {

    //Permission for buttons checked here
    //All Users Button
    let allUsersBtn;
    if(this.state.permissionForUserAdmin){
      allUsersBtn = <button className="" onClick={this.openCloseAllUsers} type="button">All Users</button>
    }
    //Create User Button
    let createUserBtn;
    if(this.state.permissionForUserAdmin){
      createUserBtn = <button onClick={this.opencloseUserCreation} type="button">Create User</button>
    }

    let createUserWindow;

    if(this.state.userCreator){
      createUserWindow = 
      <CreateUser
        close = {this.opencloseUserCreation}
      />
    }
    //Renders the list of users
    let userList;
    if(this.state.userArray.length > 0){
      let color;
      userList = this.state.userArray.map((user, index) =>
      <tr className={user.userStatus} key={index}>
        <th>{user.username}</th>
        <th>{user.userStatus}</th>
      </tr>
      )
    }else{
      userList =
      <tr>
        <th>No user found yet</th>
        <th>Offline</th>
      </tr>
    }
    //Creates an alert if necessary
    let windowAllUsersHTML;
    if(this.state.allUsersWindow){
      windowAllUsersHTML = <AllUsers close={this.openCloseAllUsers}/>
    }
    return(
        <div className='board'>
          {createUserWindow}
          {windowAllUsersHTML}
            <header>
              <div className="row">
                <div className='col-12'>
                  <h2>Users</h2>
                </div>
              </div>
            </header>
            <div className='wrapper'>
              <div className="notification-board container-fluid">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {userList}
                </tbody>
              </table>
              </div>
            </div>
            <footer>
              <div className="row">
                <div className='col-12'>
                  <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    {allUsersBtn}
                    {createUserBtn}     
                    <button className="" onClick={this.loadUsers} type="button">
                      <img className='button-icon' src={refreshIcon}></img>
                    </button>
                  </div>
                </div>
              </div>
            </footer>
        </div>
    );
  }
}

export default UserBoard;